import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@material-ui/core";
import { MI } from "./icons";
import { COLORS } from "./theme";

interface Props {
  open: boolean;
  title: string;
  body: string;
  label: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDialog: React.FC<Props> = ({
  open,
  title,
  body,
  label,
  onConfirm,
  onCancel,
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogTitle style={{ paddingBottom: 6 }}>
      <span style={{ fontSize: 16, fontWeight: 500 }}>{title}</span>
    </DialogTitle>
    <DialogContent>
      <DialogContentText style={{ fontSize: 13.5, color: COLORS.ink2, lineHeight: 1.55, margin: 0 }}>
        {body}
      </DialogContentText>
    </DialogContent>
    <DialogActions style={{ padding: "8px 22px 18px" }}>
      <Button
        onClick={onCancel}
        style={{
          background: COLORS.card,
          border: `1px solid ${COLORS.line}`,
          color: COLORS.ink2,
          textTransform: "none",
          borderRadius: 8,
          padding: "6px 13px",
          font: "500 12.5px/1 'DM Sans', sans-serif",
        }}
      >
        <MI name="x" size={16} style={{ marginRight: 6 }} />
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        style={{
          background: COLORS.brand,
          color: "#fff",
          textTransform: "none",
          borderRadius: 8,
          padding: "6px 13px",
          font: "500 12.5px/1 'DM Sans', sans-serif",
        }}
      >
        <MI name="check" size={16} style={{ marginRight: 6 }} />
        {label}
      </Button>
    </DialogActions>
  </Dialog>
);
